export const dgiMapping = (productName) => {
  const map = new Map();

  map.set('DGI Balanced Fund IRA', 'DGI Balanced Fund IRA');
  map.set('DGI Contribution', 'DGI Contribution');
  map.set('DGI Aportaciones', 'DGI Contribution');

  return map.get(productName);
};
